import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import map from 'lodash/map'
import findIndex from 'lodash/findIndex'
import Button from '@SiteComponents/Button'
import Popup from '@SiteComponents/Popup'
import SearchDropdown from '@SiteComponents/SearchDropdown'
import Cancel from '@Images/new_project_popup_cancel.svg'
import Continue from '@Images/new_project_popup_continue.svg'

import {
  closeMoveToOtherWorkspacePopup,
} from '@SiteModules/Popup/actions'

import {
  moveProjectsToOtherWorkspace,
} from '@SiteModules/Account/actions'

import {
  getCurrentAccountId,
} from '@SiteModules/Account/selectors'

import {
  getWorkspaces,
  getCurrentWorkspaceName,
  getCurrentWorkspaceId,
} from '@SiteModules/Workspace/selectors'

import {
  getSelectedProjectIds,
} from '@SiteModules/Project/selectors'

import './MoveToOtherWorkspacePopup.scss'

const MoveToOtherWorkspacePopup: React.FC = () => {
  const dispatch = useDispatch()
  const currentAccountId = useSelector(getCurrentAccountId)
  const workspaces = useSelector(getWorkspaces)
  const currentWorkspaceId = useSelector(getCurrentWorkspaceId)
  const currentWorkspaceName = useSelector(getCurrentWorkspaceName)
  const selectedProjectIds = useSelector(getSelectedProjectIds)

  const workspaceNames = map(workspaces, workspace => workspace.attributes.name)
  const workspaceIds = map(workspaces, workspace => workspace.id)
  const moreThanOneProjectSelected = selectedProjectIds.length > 1
  const currentWorkspaceIndex = findIndex(workspaceIds, workspaceId => workspaceId === currentWorkspaceId)

  const [_selectedWorkspaceName, setSelectedWorkspaceName] = useState(currentWorkspaceName)
  const [selectedWorkspaceIndex, setSelectedWorkspaceIndex] = useState(currentWorkspaceIndex)
  const currentWorkspaceSelected = selectedWorkspaceIndex === currentWorkspaceIndex
  const selectedWorkspaceName = workspaces[selectedWorkspaceIndex].attributes.name // Since the workspace name might not be unique

  const handleClose = () => {
    dispatch(closeMoveToOtherWorkspacePopup())
  }

  const handleMoveToOtherWorkspace = () => {
    const selectedWorkspaceId = workspaces[selectedWorkspaceIndex].id

    dispatch(moveProjectsToOtherWorkspace({ projectIds: selectedProjectIds, workspaceId: selectedWorkspaceId, accountId: currentAccountId }))
    handleClose()
  }

  const renderWorkspacesDropdown = () => {
    return (
      <div
        className="MoveToOtherWorkspacePopup__dropdown-wrapper"
        id="move-to-other-workspace-popup-dropdown-wrapper"
      >
        <SearchDropdown
          availableOptions={workspaceNames}
          selectedOption={selectedWorkspaceName}
          classNameForClickOutsideListener="MoveToOtherWorkspacePopup__dropdown"
          placeholderText="Select workspace..."
          setSelectedOption={setSelectedWorkspaceName}
          setSelectedOptionIndex={setSelectedWorkspaceIndex}
          idNameOfParentContainer="move-to-other-workspace-popup-dropdown-wrapper"
        />
      </div>
    )
  }

  const renderBottom = () => {
    return (
      <div className="MoveToOtherWorkspacePopup__bottom">
        <Button
          caption="Cancel"
          icon={<Cancel />}
          onClick={handleClose}
          styleType="gray-subtle"
          size="small"
        />
        <Button
          caption="Continue"
          icon={<Continue />}
          styleType="brand"
          size="small"
          iconRight
          onClick={handleMoveToOtherWorkspace}
          disabled={currentWorkspaceSelected}
        />
      </div>
    )
  }

  return (
    <Popup
      className="MoveToOtherWorkspacePopup"
      closePopup={handleClose}
    >
      <div className="MoveToOtherWorkspacePopup__header">
        {`What workspace should the ${moreThanOneProjectSelected ? 'projects' : 'project'} be moved to?`}
      </div>
      {renderWorkspacesDropdown()}
      {renderBottom()}
    </Popup>
  )
}

export default MoveToOtherWorkspacePopup
